import { FC } from 'react';
import { User, CreditCard } from 'lucide-react';
import { cn } from '@new/lib';

export type ProfileTab =
  | 'personal-info'
  | 'bio'
  | 'billing-info'
  | 'email-settings'
  | 'password-settings'
  | 'notification-settings';

interface ProfileSidebarItem {
  id: ProfileTab;
  label: string;
  icon: FC<{ className?: string }>;
}

const SIDEBAR_ITEMS: ProfileSidebarItem[] = [
  { id: 'personal-info', label: 'Personal Info', icon: User },
  // { id: 'bio', label: 'Bio', icon: Info },
  { id: 'billing-info', label: 'Billing Info', icon: CreditCard },
  // { id: 'email-settings', label: 'Email Settings', icon: Mail },
  // { id: 'password-settings', label: 'Password Settings', icon: Lock },
  // { id: 'notification-settings', label: 'Notification Settings', icon: Bell },
];

interface ProfileSidebarProps {
  activeTab: ProfileTab;
  onTabChange: (tab: ProfileTab) => void;
  isStudent?: boolean;
}

export const ProfileSidebar: FC<ProfileSidebarProps> = ({ activeTab, onTabChange, isStudent }) => {
  const visibleItems = isStudent
    ? SIDEBAR_ITEMS
    : SIDEBAR_ITEMS.filter((item) => item.id !== 'billing-info');

  return (
    <nav className="flex flex-row overflow-x-auto md:flex-col w-full md:w-[285px] md:min-w-[250px] gap-3 bg-white rounded-lg border border-(--neutral-black-NB100) shadow-[0px_4px_32px_0px_#2424240A] py-4 px-3 h-fit">
      {visibleItems.map((item) => {
        const isActive = activeTab === item.id;
        const Icon = item.icon;

        return (
          <button
            key={item.id}
            onClick={() => onTabChange(item.id)}
            className={cn(
              'flex items-center gap-2 md:gap-3 p-2 rounded-[6px]! text-left cursor-pointer border-0 whitespace-nowrap',
              '[font-size:var(--fs-l3)]! font-medium',
              isActive
                ? 'bg-[#FE8701]/10 text-(--primary-O1100)!'
                : 'text-(--neutral-black-NB600)! hover:bg-(--neutral-white-NW800)'
            )}
          >
            <Icon className="w-4 h-4 md:w-5 md:h-5" />
            <span className="hidden sm:inline">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};
